// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1PmAh","inputDescription":"styles_inputDescription__3DwIi"};